export const values = {
  creative_cta: "Without CTAs",
  creative_size: ["vertical", "horizontal", "react"],
  messaging_sparks: ["Drug", "Copay", "Rep", "Sample", "Trial"],
  workflowWithAdds: [
    "Login",
    "Calendar/Waiting Room",
    "Patient chart",
    "Consultation",
    "Procedure",
    "Prescription",
    "Diagnosis",
  ],
};

export const htmls = {
  MedizenHoriAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenVertAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenRectAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazReactAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazVertAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazHoriAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  PrimeraReactAddWithCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraVertAddWithCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraHoriAddWithCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  MedizenReactAddWithoutCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenVertAddWithoutCTA: `<html lang="en">

<head>
    <title>300X600</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
    
    </style>

</head>

<body>
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg" alt=""/>
</body>
</html>`,
  MedizenHoriAddWithoutCTA: `<html lang="en">

<head>
    <title>728X90</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
    
    </style>

</head>

<body>
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg" alt=""/>
</body>
</html>`,

  PanazReactAddWithoutCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazVertAddWithoutCTA: `<html lang="en">

<head>
    <title>300X600</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
    
    </style>

</head>

<body>
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg" alt=""/>
</body>
</html>`,
  PanazHoriAddWithoutCTA: `<html lang="en">

<head>
    <title>728X90</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
    
    </style>

</head>

<body>
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90-CTA.jpg" alt=""/>
</body>
</html>`,

  PrimeraReactAddWithoutCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraVertAddWithoutCTA: `<html lang="en">

<head>
    <title>300X600</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
    
    </style>

</head>

<body>
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg" alt=""/>
</body>
</html>`,
  PrimeraHoriAddWithoutCTA: `<html lang="en">

<head>
    <title>728X90</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
    
    </style>

</head>

<body>
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg" alt=""/>
</body>
</html>`,

  MedizenReactAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenVertAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenHoriAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenReactAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenVertAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenHoriAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  MedizenReactAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenVertAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenHoriAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenReactAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenVertAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  MedizenHoriAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Medizen</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  PanazReactAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazVertAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazHoriAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazReactAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazVertAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazHoriAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  PanazReactAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazVertAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazHoriAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazReactAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazVertAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PanazHoriAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Panaz</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  PrimeraReactAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraVertAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraHoriAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraReactAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraVertAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraHoriAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,

  PrimeraReactAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraVertAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraHoriAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraReactAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraVertAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
  PrimeraHoriAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 1px solid #ccc; box-sizing: border-box;}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview" style="position: relative; display: inline-block;"></div>
</body>
</html>`,
};